/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PropertyLocalCreateType = typeof PropertyLocalCreateType[keyof typeof PropertyLocalCreateType];


export const PropertyLocalCreateType = {
  date: 'date',
  person: 'person',
  text: 'text',
} as const;
